import 'number-to-text/converters/en-us'

import numberToText from 'number-to-text'
import PropTypes from 'prop-types'
import React from 'react'

const BuyRadioInput = ({
  dataCyPrefix,
  pricePromozione,
  label,
  values = [],
  tooltip,
  update,
  defaultValue,
  liClassName,
  spanClass,
  disabled,
  disableLastClass,
}) => {
  const tip = _tooltip =>
    _tooltip ? (
      <div className={'help-label left'}>
        <span className={'help-tip'}>{_tooltip}</span>
      </div>
    ) : null

  const l = numberToText.convertToText(values.length, { case: 'lowerCase' })

  const radios = values.map((v, i, a) => {
    const first = i === 0 ? 'first' : null
    const last = i === a.length - 1 && !disableLastClass ? 'last' : null
    const css = ['radio-buttons', 'big', l, first, last]

    return (
      <label
        className={css.join(' ')}
        data-cy={`${dataCyPrefix}${v.value?.toString()?.toLowerCase()}`}
        key={`label-${i}`}
      >
        <input
          checked={v.value === defaultValue}
          data-hj-suppress
          disabled={disabled}
          name={label}
          onChange={update}
          type={'radio'}
          value={v.value}
        />
        <span className={spanClass || 'value'}>
          <span>{v.label}</span>
        </span>
        {!!pricePromozione && (
          <div className={'radio-price'}>
            {!!v.description && <p>{v.description()}</p>}
            {pricePromozione}
          </div>
        )}
      </label>
    )
  })

  return (
    <li className={liClassName || 'wide'}>
      {radios}
      {tip(tooltip)}
    </li>
  )
}

BuyRadioInput.defaultProps = {
  disabled: false,
  disableLastClass: false,
  dataCy: '',
}

BuyRadioInput.propTypes = {
  label: PropTypes.string.isRequired,
  dataCy: PropTypes.string.isRequired,
  values: PropTypes.array.isRequired,
  update: PropTypes.func.isRequired,
  tooltip: PropTypes.string,
  disabled: PropTypes.bool,
  liClassName: PropTypes.string,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  disableLastClass: PropTypes.bool,
}

export default BuyRadioInput
